import React from 'react'
import FillCheckSvg from 'images/modules/Shared/i-fill-check.svg?raw'

export { default as FillCheckUrl } from 'images/modules/Shared/i-fill-check.svg'

export default props => (
  <span role='presentation' {...props} dangerouslySetInnerHTML={{__html: FillCheckSvg}} />
)
